import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment'
import { Observable } from 'rxjs';
import { Grant } from '@models/grant.model';

@Injectable({
    providedIn: 'root'
})
export class GrantService {

    constructor(private http: HttpClient) {}

    fetch() : Observable<HttpResponse<Grant[]>> {
        return this.http.get<Grant[]>(env.API_URL + '/grants', {
            params: { limit: 1000 }, 
            observe: 'response'
        });
    }

    static get(endpoint_id: number | undefined): boolean { 

        console.log("Grant service called");

        if (endpoint_id == undefined) {
            return true;
        }

        const s = localStorage.getItem('grants')?.toString();
    
        if (s == undefined) {
            throw new Error('Grants not set');
        }

        const grants: Grant[] = <Grant[]>JSON.parse(s);
        const grant: Grant | undefined = grants.find(i => i.endpoint_id == endpoint_id);

        if (grant == undefined) {
            return false;
        }

        let date = new Date();
        let start = new Date(grant.start);
        let end = new Date(grant.end);

        if (start > date) {
            return false;
        }

        if (end < date) {
            return false;
        }
        
        return true; 
        
    }

    static save(grants: Grant[]) {

        localStorage.setItem('grants', JSON.stringify(grants));
    }

    static clear() {
      
        localStorage.removeItem('grants');
    }
}

